import React from 'react';
import { GiftCardBalancePage as GiftCardBalancePageType, Modules } from '~/lib/data-contract';
import { GiftCardBalance } from '~/features/gift-card-balance/GiftCardBalance';
import { DynamicBlockList } from '~/templates/blocks';

type GiftCardBalancePageProps = GiftCardBalancePageType;

export const GiftCardBalancePage = ({ page }: GiftCardBalancePageProps) => {
    return (
        <>
            <GiftCardBalance headline={page.headline?.text} description={page.descriptionText} />
            <DynamicBlockList elements={page.pageElements as Modules[]} />
        </>
    );
};
